import { INSTRUCTION_TYPE, INSTRUCTION_STATUS } from "@/types/instruction";

// enum(string) → id
export function getTypeId(type: INSTRUCTION_TYPE, codeValues: any): number {
  return codeValues?.INSTRUCTION_TYPE?.find((t: any) => t.code === type)?.id ?? 10;
}

export function getStatusId(status: INSTRUCTION_STATUS, codeValues: any): number {
  return codeValues?.INSTRUCTION_STATUS?.find((s: any) => s.code === status)?.id ?? 20;
}

// id → enum(string)
export function getTypeEnum(id: number, codeValues: any): INSTRUCTION_TYPE | undefined {
  return codeValues?.INSTRUCTION_TYPE?.find((t: any) => t.id === id)?.code as INSTRUCTION_TYPE;
}

export function getStatusEnum(id: number, codeValues: any): INSTRUCTION_STATUS | undefined {
  return codeValues?.INSTRUCTION_STATUS?.find((s: any) => s.id === id)?.code as INSTRUCTION_STATUS;
}
